import { ReactElement } from 'react'

export default (): ReactElement => (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12.1602" cy="12.5" r="7" stroke="white" strokeOpacity="0.6" strokeWidth="2" />
    <path d="M12.1602 9V13L15.6602 15.5" stroke="white" strokeOpacity="0.6" strokeWidth="1.5" />
  </svg>
)
